export default "__VITE_ASSET__CyqVZFip__"